import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { NavOuterWrapper, NavContainer, PillNavGroup, FloatingPill, MobileBottomBar, NavSayHello, NavLinkedIn, NavBottomPillInactive } from './styles';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const EmailIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M2 7l10 7 10-7" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const HomeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
    <path d="M9 21V12h6v9" />
  </svg>
);

const WorkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
  </svg>
);

const AboutIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
  </svg>
);

const TalksIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

/* Pill item — left-to-right slide hover via CSS class */
const NavPillItem = ({ children, active, ...props }) => (
  <span className={active ? 'nav-pill-active' : 'nav-pill-inactive'} {...props}>
    {children}
  </span>
);

/* Mobile bottom pill item */
const BottomPillItem = ({ children, active, ...props }) => (
  active
    ? <span className="nav-bottom-pill-active" {...props}>{children}</span>
    : <NavBottomPillInactive className="nav-bottom-pill-inactive" {...props}>{children}</NavBottomPillInactive>
);

const Nav = ({ toggleMode, mode, spread }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const hash = location.hash?.replace('#', '');
    if (hash) setTimeout(() => scrollTo(hash), 0);
  }, [location]);

  return (
    <>
      <NavOuterWrapper className={visible ? 'nav-visible' : 'nav-hidden'}>
        <NavContainer>
          <div className="nav-inner">

            {/* ── Left: Avatar + Name ── */}
            <Link to="/" className="nav-brand">
              <div className="nav-avatar">G</div>
              <span className="nav-brand-name">Godfrey</span>
            </Link>

            {/* ── Center: Pill nav ── */}
            <PillNavGroup>
              <Link to="/" style={{ textDecoration: 'none' }}>
                <NavPillItem active={isHome}>Home</NavPillItem>
              </Link>
              <button onClick={() => isHome ? scrollTo('case-studies') : navigate('/#case-studies')} className="nav-btn-reset">
                <NavPillItem>Work</NavPillItem>
              </button>
              <Link to="/about" style={{ textDecoration: 'none' }}>
                <NavPillItem active={location.pathname === '/about'}>About</NavPillItem>
              </Link>
              <button onClick={() => isHome ? scrollTo('talks') : navigate('/#talks')} className="nav-btn-reset">
                <NavPillItem>Talks</NavPillItem>
              </button>
            </PillNavGroup>

            {/* ── Right: Switch + Say Hello + LinkedIn ── */}
            <div className="nav-actions">
              <NavSayHello href="mailto:kimanigodfrey4@gmail.com">
                <EmailIcon />
                Say Hello
              </NavSayHello>
              <NavLinkedIn href="https://www.linkedin.com/in/kimanigodfrey/" target="_blank" rel="noopener noreferrer">
                <LinkedInIcon />
              </NavLinkedIn>
            </div>

          </div>
        </NavContainer>
      </NavOuterWrapper>

      {/* ── Floating pill on scroll ── */}
      <FloatingPill $scrolled={scrolled}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <NavPillItem active={isHome}>Home</NavPillItem>
        </Link>
        <button onClick={() => isHome ? scrollTo('case-studies') : navigate('/#case-studies')} className="nav-btn-reset">
          <NavPillItem>Work</NavPillItem>
        </button>
        <Link to="/about" style={{ textDecoration: 'none' }}>
          <NavPillItem active={location.pathname === '/about'}>About</NavPillItem>
        </Link>
        <button onClick={() => isHome ? scrollTo('talks') : navigate('/#talks')} className="nav-btn-reset">
          <NavPillItem>Talks</NavPillItem>
        </button>
      </FloatingPill>

      {/* ── Mobile bottom nav ── */}
      {ReactDOM.createPortal(
        <MobileBottomBar>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <BottomPillItem active={isHome}><HomeIcon />Home</BottomPillItem>
          </Link>
          <button onClick={() => isHome ? scrollTo('case-studies') : navigate('/#case-studies')} className="nav-btn-reset">
            <BottomPillItem><WorkIcon />Work</BottomPillItem>
          </button>
          <Link to="/about" style={{ textDecoration: 'none' }}>
            <BottomPillItem active={location.pathname === '/about'}><AboutIcon />About</BottomPillItem>
          </Link>
          <button onClick={() => isHome ? scrollTo('talks') : navigate('/#talks')} className="nav-btn-reset">
            <BottomPillItem><TalksIcon />Talks</BottomPillItem>
          </button>
        </MobileBottomBar>,
        document.body
      )}
    </>
  );
};

export { Nav };
